export default "__VITE_ASSET__89f4a280__"